import { motion } from "framer-motion";
import { Flame, Timer, ShieldCheck, Droplets } from "lucide-react";
import { STATS } from "../../data/site";

const cards = [
  {
    icon: Droplets,
    title: "Genuine ingredients only",
    body:
      "We cook with branded, trustworthy staples — including Gemini refined oil, fresh produce and quality spices. No compromises, ever.",
    span: "md:col-span-7",
  },
  {
    icon: Timer,
    title: "Ready in 5 minutes",
    body: "Built for the rush. Hot and fresh, without the wait.",
    span: "md:col-span-5",
  },
  {
    icon: Flame,
    title: "Made fresh, all day",
    body: "Batter mixed through the day, vadas fried to order.",
    span: "md:col-span-5",
  },
  {
    icon: ShieldCheck,
    title: "Clean kitchen, honest food",
    body:
      "Hygiene we're proud of and flavour the neighbourhood keeps coming back for — from early breakfast to late-night cravings.",
    span: "md:col-span-7",
  },
];

export const Quality = () => {
  return (
    <section
      id="quality"
      data-testid="quality-section"
      className="relative bg-[#141110] px-6 lg:px-10 py-24 lg:py-32"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="max-w-2xl mb-16">
          <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#F59E0B]">
            Why SSV
          </span>
          <h2 className="mt-5 font-display uppercase text-[#F8F4EC] text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            The quality <span className="text-[#F59E0B]">promise</span>
          </h2>
        </div>

        {/* bento */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.div
                key={c.title}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: i * 0.08 }}
                data-testid={`quality-card-${i}`}
                className={`${c.span} group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-8 lg:p-10 hover:border-[#F59E0B]/40 transition-colors duration-500`}
              >
                <Icon
                  size={30}
                  className="text-[#F59E0B] mb-6 group-hover:scale-110 transition-transform duration-500"
                  strokeWidth={1.5}
                />
                <h3 className="font-display uppercase text-2xl lg:text-3xl text-[#F8F4EC] tracking-tight">
                  {c.title}
                </h3>
                <p className="mt-4 text-base leading-relaxed text-[#BFAFA6] max-w-md">
                  {c.body}
                </p>
              </motion.div>
            );
          })}
        </div>

        {/* stats */}
        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10 rounded-2xl overflow-hidden">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`stat-${i}`}
              className="bg-[#141110] p-8 lg:p-10 text-center"
            >
              <div className="font-display text-4xl lg:text-5xl text-[#F59E0B]">
                {s.value}
              </div>
              <div className="mt-3 text-xs tracking-[0.15em] uppercase text-[#BFAFA6]">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
